module.exports = "/_next/static/images/lv-56acb99bf5afda5bf99ef4b210ab1c5e.svg";